const layoutTypes = {
  HORIZONTAL: "horizontal",
  VERTICAL: "vertical",
}

const layoutWidthTypes = {
  FLUID: "fluid",
  BOXED: "boxed",
  SCROLLABLE: "scrollable",
}

const layoutModeTypes = {
  DARK: "dark",
  LIGHT: "light",
}

const topBarThemeTypes = {
  LIGHT: "light",
  DARK: "dark",
  COLORED: "colored",
}

const leftBarThemeImageTypes = {
  NONE: "none",
  IMG1: "img1",
  IMG2: "img2",
  IMG3: "img3",
  IMG4: "img4",
}

const leftSidebarTypes = {
  DEFAULT: "default",
  COMPACT: "compact",
  ICON: "icon",
}

const leftSideBarThemeTypes = {
  LIGHT: "light",
  COLORED: "colored",
  DARK: "dark",
  WINTER: "winter",
  LADYLIP: "ladylip",
  PLUMPLATE: "plumplate",
  STRONGBLISS: "strongbliss",
  GREATWHALE: "greatwhale",
}

const PrinterTypes = [
  {
    value: 0,
    label: " ",
  },
  {
    value: 1,
    label: "UV Flat",
  },
  {
    value: 2,
    label: "Eco Solvent",
  },
  {
    value: 3,
    label: "Sublimination",
  },
  {
    value: 4,
    label: "Cnc",
  },
  {
    value: 5,
    label: "UV Print",
  },
]
const PrinterTypesObject = {
  0:  " ",
  1: "UV Flat",
  2: "Eco Solvent",
  3: "Sublimination",
  4: "Cnc",
  5: "UV Print",
}

export {
  layoutTypes,
  PrinterTypesObject,
  layoutModeTypes,
  layoutWidthTypes,
  topBarThemeTypes,
  leftBarThemeImageTypes,
  leftSidebarTypes,
  leftSideBarThemeTypes,
  PrinterTypes
}
